import styles from './LeaderboardHeader.module.css'

const LeaderboardHeader = () => {
    return (
        <div className={styles.leaderboardHeader}>
            <div className={styles.leaderboardHeader__content}>
                <div className={styles.leaderboardHeader__title}>
                    Leader’s
                </div>
                <div className={styles.subtitle}>
                    Занимай места среди топ-игроков<br/>и получай награды!
                </div>
            </div>
        </div>
    )
}

export default LeaderboardHeader